<script>
    import { onMount, tick } from "svelte";

    import ChanForm from "./ChanForm.svelte";
    import ChanThread from "./ChanThread.svelte";

    export let id;
    let domain = "https://theconspiracyclub.gr";
    let promise;
    let data = null;
    let poller;

    async function getThread(e = { detail: "" }) {
        const res = await fetch(
            "/api/episode/" + id + "/comments",
        );
        const json = await res.json();

        if (res.ok) {
            data = json;

            await tick();
            if (e.detail) {
                document
                    .getElementById(e.detail)
                    .scrollIntoView({ behavior: "smooth" });
            }
        } else {
            throw new Error(text);
        }
    }

    function setupPoller() {
        if (poller) {
            clearInterval(poller);
        }
        poller = setInterval(getThread, 20000);
    }

    onMount(() => {
        promise = getThread();
        setupPoller();

        return () => clearInterval(poller);
    });
</script>

<ChanForm {id} on:update={getThread} />
<ChanThread json={data} on:update={getThread} />
